import { WritableDraft } from "immer";
import isNil from "lodash/isNil";
import mapValues from "lodash/mapValues";
import { FiltersV2StoreType } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { areFilterValuesEmpty, getEmptyValue } from "PFCore/helpers/filters";
import { FiltersMetaV2, FiltersV2, FilterV2, FilterV2WithValueOnly } from "PFTypes/filters_v2";

const getFilterWithInitializedValue = (filter: FilterV2): FilterV2 => {
  if (isNil(filter.value)) {
    return { ...filter, value: getEmptyValue(filter) };
  }

  return filter;
};

export const resetMainFilters = (draftState: WritableDraft<FiltersV2StoreType>, newFilters: FiltersV2) => {
  draftState.mainFilters = mapValues(newFilters, getFilterWithInitializedValue);
  draftState.buffer.mainFilters = mapValues(newFilters, getFilterWithInitializedValue);
};

export const resetChildrenFilters = (
  draftState: WritableDraft<FiltersV2StoreType>,
  newChildren: FiltersV2
) => {
  draftState.childrenFilters = mapValues(newChildren, getFilterWithInitializedValue);
  draftState.buffer.childrenFilters = mapValues(newChildren, getFilterWithInitializedValue);
  draftState.areChildrenOn = !areFilterValuesEmpty(newChildren);
  draftState.buffer.areChildrenOn = draftState.areChildrenOn;
};

export const resetAll = (
  draftState: WritableDraft<FiltersV2StoreType>,
  initialFilters?: FiltersMetaV2<FilterV2WithValueOnly>
) => {
  resetMainFilters(draftState, {});
  resetChildrenFilters(draftState, {});
  draftState.initialFilters = initialFilters;
  draftState.searchId = undefined;
};
